module.exports = __webpack_public_path__ + "static/media/leagueDefaultImage.ddda54c8.jpg";